<template>
    <!-- BEGIN: Content-->
    <div class="mt-0">
      <div class="flex">
        <div class="section_title"><span class="big-size weight-bold">{{ $store.state.loader_text }}&nbsp;&nbsp;</span>
          <div class="load"><v-progress-circular
            color="primary"
            indeterminate
            :size="18"
            :width="3"
            v-show="loader"
          ></v-progress-circular></div>
        </div>

        <div style="display:flex;align-items:center;justify-content:space-between;flex-direction:row">
          <v-text-field
              v-model="searchfilter"
              label="Search"
              solo
              hide-details="auto"
              class="search_"
            ></v-text-field>
          <v-btn
            color="#000000"
            class="ma-1 white--text"
            depressed
            @click="addPayment"
          >
            Add
            <v-icon
              right
              dark
            >
              mdi-plus
            </v-icon>
          </v-btn>
        </div>
      </div>
      <div class="witholdingPaymentList">
        <v-container fluid style="padding-top:0 !important;padding-bottom:0 !important">
          <v-row style="margin-top:0 !important;margin-bottom:0 !important">
            <v-col md="12" sm="12" class="my-1 py-0 px-0">
              <v-card class="card-shadow py-0">
                <v-card-title class="mt-0 pt-0">
                  <v-tabs
                    v-model="tab"
                    horizontal
                   >
                    <v-tab link :to='{name:"witholdingsList"}'>Witholding Tax</v-tab>
                    <v-tab class="mx-2" link :to='{name:"taxPaymentList"}'>Tax Payments</v-tab>
                  </v-tabs>
                </v-card-title>
                <v-card-text class="px-0 pt-1 pb-3 cardtext_tax">
                  <div class="empty-state" v-if="taxpayments.length === 0 && !loader">
                    <div class="empty-state__content">
                      <div class="empty-state__icon">
                        <v-img src="@/assets/icon.png" alt=""></v-img>
                      </div>
                      <div class="empty-state__message">No records available.</div>
                    </div>
                  </div>

                  <v-virtual-scroll
                    :items="taxpayments"
                    :item-height="20"
                    renderless 
                    id="virtualscroll"
                   >
                    <template v-slot:default="{ item }">
                        <div class="tcell">{{ moment(item.date).format('MMM Do YYYY') }}</div>
                        <div class="tcell"><span style="color:#F98525 !important;text-decoration:none !important">{{ item.tax_payment_no }}</span></div>
                        <div class="tcell">{{ item.reference_no }}</div>
                        <div class="tcell">
                          <span v-if="item.organisation_name !== null">{{ item.organisation_name }}</span>
                          <span v-else>NA</span>
                        </div>
                        <div class="tcell">
                          <span v-if="item.witholding_tax_no !== null">{{ item.witholding_tax_no }}</span>
                          <span v-else>NA</span>
                        </div>
                        <div class="tcell">KES<span style="font-weight:600 !important">{{ item.amount | currency(' ') }}</span></div>
                        <div class="tcell">
                          <v-menu offset-x left bottom origin="center center" transition="scale-transition">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  icon
                                  v-bind="attrs"
                                  small
                                  v-on="on">
                                <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
                              </v-btn>
                            </template>
                            
                            <v-list-item-group
                              color="primary"
                              class="actions"
                              >

                                <v-list-item
                                  v-if="item.witholding_tax_no == null"
                                  @click="linkpayment(item.id,item.tax_payment_no)"
                                  >
                                    <v-list-item-icon>
                                      <v-icon color="#000000">mdi-link-variant</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title>Link Payment</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item
                                  @click="updatepayment(item.id)"
                                >
                                    <v-list-item-icon>
                                      <v-icon color="#000000">mdi-pencil</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title>Edit</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>

                              <v-list-item
                                link
                                @click="deletePayment(item.id)"
                                >
                                    <v-list-item-icon>
                                      <v-icon>mdi-delete</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                      <v-list-item-title>Remove</v-list-item-title>
                                    </v-list-item-content>
                              </v-list-item>

                            </v-list-item-group>
                          </v-menu>
                        </div>
                    </template>
                  </v-virtual-scroll>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
       
        <!-- components -->
        <PayWitholding v-model="paymentdialog"/>
        <LinkPayment v-model="linkpaymentdialog"/>
        <UpdatePayment v-model="updatepaymentdialog"/>

      </div>
    </div>

</template>
<style>
  .witholdingPaymentList .v-virtual-scroll__item{
    width:100%;
    display: grid !important;

     grid-auto-columns: minmax(14.2857%, 14.2857%) !important;
     /*grid-template-columns: 12.5% 10.5% 10.5% 18.5% 10.5% 12.5% 12.5% 12.5%;*/
     grid-auto-flow: column !important;
     grid-gap: 0px;
  }
  .v-tabs-bar,.v-tabs-bar__content{
    background-color: #fff !important;
  }
  .v-tabs-items{
    background-color: #fff !important;
    margin-top:.3rem !important;
  }
  .witholdingPaymentList .v-slide-group__content {
    padding: 1rem 0rem !important;
  }
  .theme--light.v-tabs>.v-tabs-bar,.v-tabs-slider{
    background: transparent !important;
  }
  .v-tab:hover {
    border-radius: 50px !important;
  }
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active){
    background:#f8f8f8;
  }
</style>
<style scoped>

    .v-tabs ::v-deep .v-tabs-slider-wrapper {
      transition: none !important;
    }
    .v-tabs-slider-wrapper{
      display: none !important;
    }
    .v-slide-group__content{
      width:100% !important;
      justify-content: flex-end !important;
    }
    .v-tab{
      padding:.2rem 1.5rem !important;
      background:#FFFFFF;
      border-radius: 50px !important;
      height:1.8rem !important;
    }
    .v-tab.v-tab--active{
      background:#DEC7FF;
    }

</style>
<script>
import axios from 'axios'
import {ability} from '@/services/ability'
import $ from 'jquery';
import PayWitholding from '@/components/witholding/paywitholding'
import LinkPayment from '@/components/witholding/linkpayment'
import UpdatePayment from '@/components/witholding/updatepayment'

export default {
    name:"taxPaymentList",
    components: {PayWitholding,LinkPayment,UpdatePayment},
    data(){
        return {
          fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
          ],
          searchfilter:'',
          search:null,
          valid: true,
          tab: null,
          paymentdialog: false,
          linkpaymentdialog: false,
          updatepaymentdialog: false,
          searchcategory:null,
          searchinvoice:null,
          searchstatus:null,
          dialog: false,
          tableloader: false,
          updatedialog: false,

          fields: [
             {
              text: 'DATE',
              align: 'start',
              value: 'date',
            },
            { text: 'PAYMENT #', value: 'paymentno' },
            { text: 'REF #', value: 'referenceno' },
            { text: 'ORGANISATION', value: 'organisation' },
            { text: 'WITHOLDING #', value: 'witholding' },
            { text: 'AMOUNT', value: 'amount' },
            { text: 'ACTION', value: 'action' },
           ],
          item:{
              invoice_id: "",
              id: "",
              tolinkreceipt: "",
              _method:"patch"
          },
            isBusy: false,
            loading: false,
           disabled: false,
           orgCategory: [],
           orgType: [],
           organisation: [],
           height: '100%',
            rowHeight: 25,
            perPage: 50,
            start: 0,
            timeout: null ,
            selectedItem: false,
            invoices: []
        }
    },
    beforeMount() {
      if(!ability.can('organisation-management', 'all')) {
        this.$router.push({ name: 'Dashboard' })
        return
      }
    },
    mounted(){

      this.$store.state.loader_text = "Tax Payment"

      if(!this.taxpayments || this.taxpayments.length == 0) {
        this.gettaxpayment()
      }

      let headertitle = `<div class="v-virtual-scroll__container"><div class="v-virtual-scroll__item" style="top: 0px;">`;
      this.fields.map(function(value, key) {
           headertitle +=`<div class="thead">${value.text}</div>`;
         });
      headertitle +=`</div></div>`;
      $('.v-virtual-scroll').prepend(headertitle)

    },
    serverPrefetch () {
    },
    computed: {
      loader() {
        return this.$store.state.tableloader
      },
      payments() {

        return this.$store.state.witholdingpayments.filter(item => {

          this.start = 0

          let witholding_tax_no = "";
          let tax_payment_no = "";
          let reference_no = "";
          let organisation = "";

          if(item.organisation != null) {
            organisation = item.organisation.name
          }
          if(item.tax_payment_no !== null) {
            tax_payment_no = item.tax_payment_no
          }
          if(item.reference_no !== null) {
            reference_no = item.reference_no
          }
          if(item.witholding_tax_no !== null) {
            witholding_tax_no = item.witholding_tax_no
          }
          return tax_payment_no.toLowerCase().includes(this.searchfilter.toLowerCase()) || witholding_tax_no.toLowerCase().includes(this.searchfilter.toLowerCase()) || organisation.toLowerCase().includes(this.searchfilter.toLowerCase()) || reference_no.toLowerCase().includes(this.searchfilter.toLowerCase())
        })

      },
      taxpayments() {
        return this.payments
      },
    },

    methods:{

      addPayment() {
        this.paymentdialog = true
      },

      linkpayment(id, paymentNo) {
        this.$store.state.witholdpaymentdata = {
          id: id,
          tolinkreceipt: paymentNo
        }
        this.linkpaymentdialog = true
      },

      updatepayment(id) {
        this.$store.state.updatewitholdpaymentdata = {
          id: id
        }
        this.updatepaymentdialog = true
      },

      gettaxpayment(){
        this.$store.state.tableloader = true
        this.$store
          .dispatch('gettaxpayment')
          .then(() => {
            this.$store.state.tableloader = false
          })
          .catch(() => {
            this.$store.state.tableloader = false
          })
      },

      deletePayment(id){
            if(confirm("Are you sure to remove Payment ?")){
                axios.delete(`/tax-payment/${id}`).then(response=>{
                  let index = this.$store.state.witholdingpayments.findIndex(data => data.id == response.data.payment.id);
                  if (index > -1) {
                    this.$store.state.witholdingpayments.splice(index, 1);
                  }
                  this.$toast.success('Payment tax removed successfully','Success',{position: 'topRight',timeout: 7000,})
                }).catch(error=>{
                    console.log(error)
                })
            }
        }
    }
}
</script>